let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5knkb")).then(() => parcelRequire('aEI8u'));